import React from "react";
import ArtistName from "~/Components/Elements/ArtistName";
import ArtistFavoritesContainer from "~/Containers/ArtistFavoritesContainer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as faStarOutline } from "@fortawesome/free-regular-svg-icons";
import styled from "styled-components";

export const WrapperNoFav = styled.section`
  margin-top: 20px;
  margin-bottom: 20px;
`;
export const Wrapper = styled.section`
  line-height: 18px;
  margin: 0 10px 5px 0;
`;
const ProfileFavoriteArtists = ({ dir, isOwner }) => (
  <ArtistFavoritesContainer
    dir={dir}
    render={({ artists }) => {
      // if (!isOwner) return null;
      if (artists.length === 0 && !isOwner) return null;

      return (
        <div className="profile-right-nav profile-most-recent-purchase">
          <h3>Favorite Artists</h3>
          {artists.length === 0 && isOwner ? (
            <WrapperNoFav>
              You haven't added any favorites yet.
              <br />
              <br />
              Tip: Click the {` `}
              <FontAwesomeIcon icon={faStarOutline} /> {` `}
              on an artist page to add as a favorite. For example: <ArtistName track={{ artist: `Sorcerer` }} link={true} />
            </WrapperNoFav>
          ) : (
            <div>
              {artists.map((artist) => (
                <Wrapper>
                  <ArtistName track={{ artist: artist.name }} link={true} />
                </Wrapper>
              ))}
            </div>
          )}
        </div>
      );
    }}
  />
);

export default ProfileFavoriteArtists;
